import { useState, useEffect } from "react";
import { toast } from 'react-toastify';

const InventoryPlan = () => {
  const [vendors, setVendors] = useState([]);
  const [viewMode, setViewMode] = useState("createplan");
  const [selectedVendor, setSelectedVendor] = useState("");
  const [planName, setPlanName] = useState("");
  const [planType, setPlanType] = useState("");
  const [countryList, setCountryList] = useState("");
  const [dataLimit, setDataLimit] = useState("");
  const [validity, setValidity] = useState("");
  const [planClass, setPlanClass] = useState("");
  const [additionalInfo, setAdditionalInfo] = useState("");
  const [sellingPrice, setSellingPrice] = useState("");
  const [createdPlans, setCreatedPlans] = useState([]);


  // State
const [totalLimitGB, setTotalLimitGB] = useState(10); // default is 10 GB

const MAX_TOTAL_MB = totalLimitGB * 1024;

  const [slices, setSlices] = useState(() => {
    const stored = localStorage.getItem("dataSlices");
    return stored ? JSON.parse(stored) : [{ data: "", bitrate: "Unlimited" }];
  });
 const [activeTab, setActiveTab] = useState('data'); // 'data' or 'slices'
 
  useEffect(() => {
    const storedVendors = JSON.parse(localStorage.getItem("vendors"));
    const storedPlans = JSON.parse(localStorage.getItem("createdPlans"));
    if (storedVendors) setVendors(storedVendors);
    if (storedPlans) setCreatedPlans(storedPlans);
  }, []);

  useEffect(() => {
    if (vendors.length > 0) localStorage.setItem("vendors", JSON.stringify(vendors));
    if (createdPlans.length > 0) localStorage.setItem("createdPlans", JSON.stringify(createdPlans));
  }, [vendors, createdPlans]);

  useEffect(() => {
    localStorage.setItem("dataSlices", JSON.stringify(slices));
  }, [slices]);

  const handleCreatePlan = () => {
    if (!selectedVendor || !planName || !dataLimit) {
      return toast.error("Please fill all the fields.");
    }

    const newPlan = {
      vendor: selectedVendor,
      planName,
      planType,
      countryList,
      dataLimit,
      validity,
      planClass,
      additionalInfo,
      sellingPrice,
    };

    setCreatedPlans([...createdPlans, newPlan]);
    setPlanName("");
    setPlanType("");
    setCountryList("");
    setDataLimit("");
    setValidity("");
    setPlanClass("");
    setAdditionalInfo("");
    setSellingPrice("");
    toast.error("Plan Added Successfully!");
  };

 

  const handleDeleteSlice = (index) => {
    const updated = [...slices];
    updated.splice(index, 1);
    setSlices(updated);
  };
const handleCountryChange = (e) => {
  const selected = Array.from(e.target.selectedOptions, option => option.value);
  setCountryList(planType === 'Regional' ? selected : [selected[0]]);
};

  
const handleChange = (index, field, value) => {
  const newSlices = [...slices];

  if (field === 'data') {
    const newValue = parseInt(value, 10) || 0;
    const maxMB = totalLimitGB * 1024;

    const totalExcludingCurrent = slices.reduce((sum, s, i) => {
      return sum + (i === index ? 0 : parseInt(s.data || 0));
    }, 0);

    if (totalExcludingCurrent + newValue > maxMB) {
      toast.error(`Total data cannot exceed ${totalLimitGB} GB (${maxMB} MB). You have ${maxMB - totalExcludingCurrent} MB left.`);
      return;
    }

    newSlices[index].data = newValue;
  } else {
    newSlices[index][field] = value;
  }

  setSlices(newSlices);
};
const handleAddSlice = () => {
  const totalUsed = slices.reduce((sum, s) => sum + Number(s.data || 0), 0);
  const maxMB = totalLimitGB * 1024;

  if (totalUsed >= maxMB) {
    toast.error(`Cannot add more slices. Total limit of ${totalLimitGB} GB (${maxMB} MB) reached.`);
    return;
  }

  setSlices([...slices, { data: '', bitrate: 'Unlimited' }]);
};

  return (
    <div className="w-full h-full space-y-8 bg-white shadow-xl rounded-lg p-4 border border-[#96989a]">
      <h2 className="text-5xl font-bold text-gray-700">Create Plan</h2>

      {viewMode === "createplan" && (
        <div className="space-y-4">
          {/* Vendor Selection */}
          <div className="flex flex-col">
            <label htmlFor="vendor" className="text-sm font-semibold text-gray-700 mb-2">
              Vendor <span className="text-red-500">*</span>
            </label>
            <select
              id="vendor"
              onChange={(e) => setSelectedVendor(e.target.value)}
              value={selectedVendor}
              className="w-full p-2 border rounded-md"
            >
              <option value="">Select Vendor</option>
              <option value="Airhub">Airhub</option>
              {vendors
                .filter((vendor) => vendor.name !== "Airhub")
                .map((vendor, index) => (
                  <option key={index} value={vendor.name}>
                    {vendor.name}
                  </option>
                ))}
            </select>
          </div>

          {/* Plan Info */}
          <div className="flex gap-2">
            <div className="flex flex-col w-full">
              <label className="text-sm font-semibold text-gray-700 mb-2">
                Plan Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder="Plan Name"
                value={planName}
                onChange={(e) => setPlanName(e.target.value)}
                className="w-full p-2 border rounded-md"
              />
            </div>
 <div className="flex flex-col w-full">
              <label className="text-sm font-semibold text-gray-700 mb-2">
                Plan Class <span className="text-red-500">*</span>
              </label>
              <select
                value={planClass}
                onChange={(e) => setPlanClass(e.target.value)}
                className="w-full p-2 border rounded-md"
              >
                <option value="" disabled>Select a Class</option>
                <option value="Data">Data</option>
                <option value="Datavoice">Data and Voice</option>
              </select>
            </div>
          </div>

          

          

          <div className="flex gap-2">
            <div className="flex flex-col w-full">
              <label className="text-sm font-semibold text-gray-700 mb-2">
                Additional Information <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder="Additional Info"
                value={additionalInfo}
                onChange={(e) => setAdditionalInfo(e.target.value)}
                className="w-full p-2 border rounded-md"
              />
            </div>

            <div className="flex flex-col w-full">
              <label className="text-sm font-semibold text-gray-700 mb-2">
                Selling Price (US$) <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder="Selling Price"
                value={sellingPrice}
                onChange={(e) => setSellingPrice(e.target.value)}
                className="w-full p-2 border rounded-md"
              />
            </div>
          </div>
<div className="flex gap-2">
            <div className="flex flex-col w-full">
              <label className="text-sm font-semibold text-gray-700 mb-2">
                Validity (Days) <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder="Validity"
                value={validity}
                onChange={(e) => setValidity(e.target.value)}
                className="w-full p-2 border rounded-md"
              />
            </div>
                  <div className="flex flex-col w-full">
  <label className="text-sm font-semibold text-gray-700 mb-2">
    Plan Type <span className="text-red-500">*</span>
  </label>
  <select
    value={planType}
    onChange={(e) => {
      const value = e.target.value;
      setPlanType(value);
      setCountryList([]); // reset selection on change
    }}
    className="w-full p-2 border rounded-md"
  >
    <option value="" disabled>
      Select a Type
    </option>
    <option value="Local">Local</option>
    <option value="Regional">Regional</option>
  </select>
</div>

<div className="flex flex-col w-full">
  <label className="text-sm font-semibold text-gray-700 mb-2">
    Country/Region <span className="text-red-500">*</span>
  </label>

  <select
    multiple={planType === 'Regional'}
    value={countryList}
    onChange={handleCountryChange}
    className="w-full p-2 border rounded-md"
  >
    <option value="USA">USA</option>
    <option value="UK">UK</option>
    <option value="Canada">Canada</option>
    <option value="Australia">Australia</option>
    <option value="Germany">Germany</option>
  </select>
</div>

          </div>
         
          {/* Data Slices */}
          <div className="bg-[#f6f0e8] p-6 rounded-md max-w-xl mx-auto">
      {/* Tab Buttons */}
      <div className="flex gap-4 mb-6">
        <button
          onClick={() => setActiveTab('data')}
          className={`px-4 py-2 rounded-md shadow ${
            activeTab === 'slices' ? 'bg-white text-black' : 'bg-gray-300 text-gray-600'
          }`}
        >
          Data
        </button>
        <button
          onClick={() => setActiveTab('slices')}
          className={`px-4 py-2 rounded-md shadow ${
            activeTab === 'data' ? 'bg-white text-black' : 'bg-gray-300 text-gray-600'
          }`}
        >
          Data slices
        </button>
      </div>

      {/* Data Limit Input */}
      {activeTab === 'data' && (
        <div className="flex flex-col w-full">
          <label className="text-sm font-semibold text-gray-700 mb-2">
            Data Limit (GB) <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            placeholder="Data Limit"
            value={dataLimit}
            onChange={(e) => setDataLimit(e.target.value)}
            className="w-full p-2 border rounded-md"
          />
        </div>
      )}

      {/* Data Slices Section */}
      <div>
  {/* Data Slices Section */}
  {activeTab === 'slices' && (
    <>
      {/* Column Headers */}
      <div className="mb-4">
  <label className="font-semibold mr-2">Total Limit (GB):</label>
  <input
    type="number"
    value={totalLimitGB}
    onChange={(e) => setTotalLimitGB(Number(e.target.value))}
    className="border px-3 py-1 rounded w-32"
  />
  <span className="text-sm text-gray-600 ml-2">
    = {totalLimitGB * 1024} MB
  </span>
</div>

      <div className="flex items-center gap-4 mb-2 font-semibold">
        <div className="w-5">📶</div>
        <div className="w-40">Data (MB)</div>
        <div className="w-40">Bitrate</div>
        <div className="w-10">Delete</div>
        <div className="ml-auto text-sm text-gray-500">
          Used: {slices.reduce((sum, s) => sum + Number(s.data || 0), 0)} / 10240 MB (10 GB)
        </div>
      </div>

      {/* Slice Rows */}
      {slices.map((slice, index) => (
        <div
          key={index}
          className="flex items-center gap-4 mb-3 bg-white p-3 rounded shadow"
        >
          <div>📶</div>
          <input
            type="number"
            placeholder="Data (MB)"
            value={slice.data}
            onChange={(e) => handleChange(index, 'data', e.target.value)}
            className="border px-3 py-1 rounded w-40"
          />
          <select
            value={slice.bitrate}
            onChange={(e) => handleChange(index, 'bitrate', e.target.value)}
            className="border px-3 py-1 rounded w-40"
          >
            <option value="Unlimited">Unlimited</option>
            <option value="5120Mbps">5120 Kbps</option>
            <option value="3072kbps">3072 kbps</option>
            <option value="1024kbps">1024 kbps</option>
            <option value="512kbps">512 kbps</option>
            <option value="256kbps">256 kbps</option>
            <option value="128kbps">128 kbps</option>
            <option value="64kbps">64 kbps</option>
            <option value="32kbps">32 kbps</option>
          </select>
          <button
            onClick={() => handleDeleteSlice(index)}
            className="text-red-500 text-xl"
          >
            🗑️
          </button>
        </div>
      ))}

      {/* Add Slice Button */}
      <button
        onClick={handleAddSlice}
        className="mt-4 bg-[#f6f0e8] border border-gray-400 text-gray-700 px-4 py-2 rounded hover:bg-gray-200"
      >
        ➕ Add Slice
      </button>
    </>
  )}
</div>

    </div>

          {/* Action Buttons */}
          <div className="flex justify-end space-x-4">
            <button
              onClick={handleCreatePlan}
              className="bg-[#117575] rounded-full p-4 text-white shadow-md hover:bg-[#1cbebe]"
            >
              Create Plan
            </button>
            <button
              onClick={() => setViewMode("createplandetails")}
              className="bg-teal-500 rounded-full p-4 text-white shadow-md hover:bg-[#1cbebe]"
            >
              Plan Details
            </button>
          </div>
        </div>
      )}

      {/* Plan Details Table */}
      {viewMode === "createplandetails" && (
        <div className="overflow-x-auto">
          <table className="min-w-full border-collapse table-auto">
            <thead>
              <tr className="bg-gray-100">
                {[
                  "Vendor", "Plan Name", "Plan Type", "Country",
                  "Data Limit", "Validity(Days)", "Plan Class",
                  "Additional Info", "Selling Price", "Action"
                ].map((heading, i) => (
                  <th key={i} className="px-6 py-3 text-center">{heading}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {createdPlans.map((plan, index) => (
                <tr key={index}>
                  <td className="px-6 py-4 text-center">{plan.vendor}</td>
                  <td className="px-6 py-4 text-center">{plan.planName}</td>
                  <td className="px-6 py-4 text-center">{plan.planType}</td>
                  <td className="px-6 py-4 text-center">{plan.countryList}</td>
                  <td className="px-6 py-4 text-center">{plan.dataLimit} GB</td>
                  <td className="px-6 py-4 text-center">{plan.validity} Days</td>
                  <td className="px-6 py-4 text-center">{plan.planClass}</td>
                  <td className="px-6 py-4 text-center">{plan.additionalInfo}</td>
                  <td className="px-6 py-4 text-center">${plan.sellingPrice}</td>
                  <td className="px-6 py-4 text-center">
                    <button className="bg-green-600 text-white px-4 py-1 rounded-xl shadow">
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <button
            onClick={() => setViewMode("createplan")}
            className="bg-blue-500 text-white px-4 py-2 rounded-md hover:opacity-80 mt-4"
          >
            Create Plan
          </button>
        </div>
      )}
    </div>
  );
};

export default InventoryPlan;
